import { TextInput } from "djinn-components";

const Singular: React.FC<any> = ({ type, value = "", onChange }) => {
  return (
    <div className="mb-3">
      <label className="mb-2 block ml-4 text-sm font-medium">{type}:</label>
      <div className="col-span-5">
        <TextInput
          value={value}
          onChange={(e: any) => onChange(e.target.value)}
          invalid={false}
          placeholder={`Enter ${type} url`}
        />
      </div>
    </div>
  );
};

export default Singular;
